import { createContext } from 'react'
import { ddlListItem } from '../components/dropDownList/DropDownList'
import { IFormDataInput } from '../model/IFormDataInput'
import { ChildDataObject } from './contextDataObjects/ChildDataObject'

export interface IChildPlanFormData {
    [key: string]: any
    FirstName: string
    LastName: string
    Dob: any
    School: ddlListItem
    Plan: {
        PlanCode: string
        Primary: string
        Premium: number
        Index: number
        IsValid: boolean
    }
    ChildPlanFormDataInput: IFormDataInput[]
    SetValidationFocus: boolean
}

interface ChildPlanFormDataContextValue {
    childPlanFormData: IChildPlanFormData[]
    setChildPlanFormData: React.Dispatch<
        React.SetStateAction<IChildPlanFormData[]>
    >
}
const childPlanFormDataContext = createContext<ChildPlanFormDataContextValue>({
    childPlanFormData: [
        ChildDataObject
    ],
    setChildPlanFormData: () => [],
})

export default childPlanFormDataContext